import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"

const Header = ({ siteTitle }) => (
  <nav className="bg-gray-800 w-full">
    <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
      <div className="h-16 flex w-full items-center justify-between">
        <Link to="/" className="font-bold text-2xl text-white">
          {siteTitle}
        </Link>
        {/* <div data-netlify-identity-button></div> */}
        <div className="flex">
          <Link
            to="/admin"
            className="text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
          >
            Admin
          </Link>
          {/* <div
            data-netlify-identity-menu
            className="underline flex mr-2 text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
          /> */}
        </div>
      </div>
    </div>
  </nav>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
